<template>
  <div class="wf-absolute wf-right-0 wf-top-0 wf-text-white wf-bg-blue-300 wf-overflow-visible wf-z-100 wf-items-stretch wf-flex wf-rounded-b wf-shadow">
    <span
      class="wf-rounded-b wf-py-1 wf-block wf-px-4 wf-text-center wf-text-sm wf-bg-blue-500 wf-self-stretch wf-lowercase wf-font-light"
      v-text="name ? name : parent"
    ></span>
    <template v-for="option in options">
      <button
        v-if="! option.menu"
        :key="option.name"
        class="focus:wf-outline-none wf-rounded-b wf-inline-block wf-py-1 wf-px-2 wf-text-center hover:wf-bg-blue-500"
        :class="optionClasses(option)"
        @click.prevent="handle(option.method)"
      ><i :class="['fas', option.icon]"></i></button>
      <div
        v-else
        :key="option.name"
        :ref="option.name"
        class="wf-relative wf-overflow-visible hover:wf-bg-blue-500"
      >
        <button
          class="focus:wf-outline-none wf-rounded-b wf-inline-block wf-py-1 wf-px-2 wf-text-center"
          :class="option.classes"
          @click.prevent="handle(option.method)"
        ><i :class="['fas', option.icon]"></i></button>
        <div class="wf-hidden" :ref="`${option.name}_menu`">
          <component :is="option.menu" :parent="parentElement" :parentModule="parentModule"></component>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {UuidGenerator} from '../UuidGenerator'
import {RowFactory} from '../factories/RowFactory'
import ArrayManipulation from '../mixins/ArrayManipulation'
import CarouselMenu from './EditorMenus/CarouselMenu'
import ColumnMenu from './EditorMenus/ColumnMenu'
import ComponentColumnMenu from './EditorMenus/ComponentColumnMenu'
import PopUpMenu from './EditorMenus/PopUpMenu'
import ComponentRowColumnsMenu from './EditorMenus/ComponentRowColumnsMenu'
import ComponentRowMenu from './EditorMenus/ComponentRowMenu'
import ComponentSectionMenu from './EditorMenus/ComponentSectionMenu'
import RowColumnsMenu from './EditorMenus/RowColumnsMenu'
import RowMenu from './EditorMenus/RowMenu'
import SectionMenu from './EditorMenus/SectionMenu'
import SeparatorMenu from './EditorMenus/SeparatorMenu'
import BannerMenu from './EditorMenus/BannerMenu'
import AccordionMenu from './EditorMenus/AccordionMenu'
import HeaderMenu from './EditorMenus/HeaderMenu'
import FormMenu from './EditorMenus/FormMenu'
import AlertMenu from './EditorMenus/AlertMenu'
import ButtonMenu from './EditorMenus/ButtonMenu'
import HtmlCodeMenu from './EditorMenus/HtmlCodeMenu'
import HeadingMenu from './EditorMenus/HeadingMenu'
import IconMenu from './EditorMenus/IconMenu'
import ProgressBarMenu from './EditorMenus/ProgressBarMenu'
import ListsMenu from './EditorMenus/ListsMenu'
import SingleImageMenu from './EditorMenus/SingleImageMenu'
import SocialProofBubbleMenu from './EditorMenus/SocialProofBubbleMenu'
import TabsMenu from './EditorMenus/TabsMenu'
import TextEditorMenu from './EditorMenus/TextEditorMenu'
import VideoMenu from './EditorMenus/VideoMenu'
import PricingTableMenu from './EditorMenus/PricingTableMenu'
import GoogleMapsMenu from './EditorMenus/GoogleMapsMenu'
import CounterMenu from './EditorMenus/CounterMenu'
import GalleryMenu from './EditorMenus/GalleryMenu'
import BlogPostsMenu from './EditorMenus/BlogPostsMenu'

export default {
    props: {
      parentModule: {
        type: String,
        required: false
      },
      overrideElement: {
        type: Object,
        required: false,
        default: null
      },
      parent: {
        type: String,
        required: true,
      },
      name: {
        type: String,
        required: false
      },
      options: {
        type: Array,
        required: true
      }
    },
    mixins: [ArrayManipulation],
    components: {
      AccordionMenu,
      AlertMenu,
      BannerMenu,
      ButtonMenu,
      CarouselMenu,
      ColumnMenu,
      ComponentColumnMenu,
      ComponentRowColumnsMenu,
      ComponentRowMenu,
      ComponentSectionMenu,
      CounterMenu,
      FormMenu,
      GoogleMapsMenu,
      HeadingMenu,
      HeaderMenu,
      HtmlCodeMenu,
      IconMenu,
      ListsMenu,
      PopUpMenu,
      PricingTableMenu,
      ProgressBarMenu,
      RowColumnsMenu,
      RowMenu,
      SectionMenu,
      SeparatorMenu,
      SingleImageMenu,
      SocialProofBubbleMenu,
      TabsMenu,
      TextEditorMenu,
      VideoMenu,

      BlogPostsMenu,

      GalleryMenu,
    },
    mounted() {
      this.activateHoverable()
    },
    computed: {
      parentElement() {
        return this.$parent
      },
      elementSidebar() {
        return this.$store.getters['settingsModule/elementSidebar']
      },
      elementModule() {
        if (this.parentElement.module == 'componentRowModule') {
          return 'componentSectionModule'
        }
        if (this.parentElement.module == 'topSectionModule') {
          return 'topSectionModule'
        }
        if (this.parentElement.module == 'bottomSectionModule') {
          return 'bottomSectionModule'
        }
        return this.parentElement.parent.module
      },
      elementToolbar() {
        return this.$store.state.elementToolbar
      },
      elementFamily() {
        return this.parentElement.family
      },
      element() {
        if (this.overrideElement) {
          return this.overrideElement
        }
        return this.parentElement.element
      },
      editingElement() {
        return this.$store.state.editingElement
      },
    },
    methods: {
      copyElement() {
        let id  = `${this.parentElement.name}_${(new UuidGenerator).build()}`
        let element = JSON.parse(JSON.stringify({...this.$store.getters[`${this.parentElement.module}/elements`](this.element, this.parentModule), id: id}))
        this.addToArray(this.elementModule, [element], this.parentElement.family, null, {}, true, this.parentModule)
      },
      optionClasses(option) {
        if (this.elementModule == 'componentColumnModule') {
          return ['component-component-handle']
        }
        return option.classes
      },
      activateHoverable() {
        let hoverableOptions = this.options.filter(hoverableOption => hoverableOption.hoverable)
        hoverableOptions.forEach(hoverableOption => {
          if (this.elementSidebar && hoverableOption.name == 'settings') {
            return
          }
          this.$refs[hoverableOption.name][0].addEventListener('mouseover', () => {
            this.$refs[`${hoverableOption.name}_menu`][0].classList.remove('wf-hidden')
          })
          this.$refs[hoverableOption.name][0].addEventListener('mouseleave', () => {
            this.$refs[`${hoverableOption.name}_menu`][0].classList.add('wf-hidden')
          })
        })
      },
      openMenu() {
        if (! this.elementSidebar) {
          return
        }
        let open = false

        if (this.element == this.editingElement && ! this.elementToolbar) {
          open = true
        }

        this.$store.commit('toggleElementToolbar', {
          element: this.element,
          module: this.parentElement.module,
          open: open,
          parentModule: this.parentModule
        })
      },
      newRows(qty = 1) {
        return (new RowFactory(qty)).create()
      },
      handle(method) {
        method ? this[method]() : null
      },
      addComponent() {
        let modalPayload = this.element
        if (Object.prototype.hasOwnProperty.call(this.element, 'componentColumn')) {
          modalPayload = {
            ...this.element,
            innerComponent: true
          }
        }

        if (this.parentModule == 'topSectionModule' || this.parentModule == 'bottomSectionModule') {
          modalPayload = {
            ...this.element,
            section: 0,
            layoutSectionComponent: true,
            parentModule: this.parentModule
          }
        }
        this.$modal.show('newComponentModal', modalPayload)
      },
      removeParent() {
        this.$store.commit('toggleElementToolbar', {
          element: null,
          module: null,
          open: false
        })
        
        if(! window.confirm('Are you sure you want to remove this element?')) {
          return
        }
        
        if (this.parentModule == 'topSectionModule' && this.elementModule === 'layoutSectionModule') {
          return this.addToObject('layoutModule', null, 'topSection')
        }
        if (this.parentModule == 'bottomSectionModule' && this.elementModule === 'layoutSectionModule') {
          return this.addToObject('layoutModule', null, 'bottomSection')
        }

        this.removeFromArray(
          this.elementModule,
          [this.$store.getters[`${this.parentElement.module}/elements`](this.element, this.parentModule)],
          this.elementFamily,
          null,
          {},
          true,
          this.parentModule
        )
      },
      addRow() {
        let elementModule = 'sectionModule'
        if (this.parentModule != 'layoutPageComponentModule') {
          elementModule = this.parentModule
        }
        if (
          Object.prototype.hasOwnProperty.call(this.element, 'component') ||
          Object.prototype.hasOwnProperty.call(this.element, 'pageComponent') ||
          Object.prototype.hasOwnProperty.call(this.element, 'layoutPageComponent')
        ) {
          elementModule = 'componentSectionModule'
        }
        this.addToArray(elementModule, this.newRows(), 'rows', null, {}, true, this.parentModule)
      },
    }
  }
</script>
